import { render } from "./MetroSearchPopup.vue?vue&type=template&id=70f6502c&scoped=true"
import script from "./MetroSearchPopup.vue?vue&type=script&lang=js"
export * from "./MetroSearchPopup.vue?vue&type=script&lang=js"

import "./MetroSearchPopup.vue?vue&type=style&index=0&id=70f6502c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f6502c"]])

export default __exports__